export default "__VITE_ASSET__e33d91db__"